import { DashboardRepo } from "../../data/repo";
import { DashboardRequest } from "../../models";

export class DashboardService {
  private repo: DashboardRepo;

  constructor() {
    this.repo = new DashboardRepo();
  }

  async postAsync<T= any>(request: DashboardRequest): Promise<T> {
    return await this.repo.postAsync<T>(request);
  }
}
